(function () {
  var STORAGE_KEY = 'theme_wishlist_v1';
  var TOAST_TIMEOUT = 2200;

  function readWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function writeWishlist(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: items }));
  }

  function normalizeItem(item) {
    return {
      key: String(item.variant_id || item.id),
      id: String(item.id || ''),
      variant_id: String(item.variant_id || ''),
      handle: item.handle || '',
      url: item.url || '',
      title: item.title || '',
      variant_title: item.variant_title || '',
      image: item.image || '',
      price: item.price || '',
      quantity: Math.max(parseInt(item.quantity || 1, 10) || 1, 1)
    };
  }

  function getItems() {
    return readWishlist().map(normalizeItem);
  }

  function setItems(items) {
    writeWishlist(items.map(normalizeItem));
  }

  function getWishlistKey(button) {
    return String(button.getAttribute('data-variant-id') || button.getAttribute('data-product-id'));
  }

  function hasProduct(buttonOrKey) {
    var key = typeof buttonOrKey === 'string' ? buttonOrKey : getWishlistKey(buttonOrKey);
    return getItems().some(function (item) {
      return item.key === String(key);
    });
  }

  function toggleProduct(product) {
    var items = getItems();
    var key = String(product.variant_id || product.id);
    var exists = items.some(function (item) {
      return item.key === key;
    });

    if (exists) {
      items = items.filter(function (item) {
        return item.key !== key;
      });
    } else {
      items.push(normalizeItem(product));
    }

    setItems(items);
    return !exists;
  }

  function updateQuantity(key, quantity) {
    var items = getItems().map(function (item) {
      if (item.key === String(key)) {
        item.quantity = Math.max(parseInt(quantity, 10) || 1, 1);
      }
      return item;
    });

    setItems(items);
  }

  function removeProduct(key) {
    setItems(
      getItems().filter(function (item) {
        return item.key !== String(key);
      })
    );
  }

  function updateCount() {
    var count = getItems().length;

    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'inline-flex' : 'none';
    });

    var pageCount = document.querySelector('[data-wishlist-page-count]');
    if (pageCount) {
      pageCount.textContent = count + ' item' + (count === 1 ? '' : 's');
    }
  }

  function updateButtons(scope) {
    var root = scope || document;

    root.querySelectorAll('[data-wishlist-button]').forEach(function (button) {
      var active = hasProduct(button);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function bindButtons(scope) {
    var root = scope || document;

    root.querySelectorAll('[data-wishlist-button]').forEach(function (button) {
      if (button.dataset.bound === 'true') return;
      button.dataset.bound = 'true';

      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        var product = {
          id: button.getAttribute('data-product-id'),
          variant_id: button.getAttribute('data-variant-id'),
          handle: button.getAttribute('data-product-handle'),
          url: button.getAttribute('data-product-url'),
          title: button.getAttribute('data-product-title'),
          variant_title: button.getAttribute('data-variant-title'),
          image: button.getAttribute('data-product-image'),
          price: button.getAttribute('data-product-price'),
          quantity: 1
        };

        var added = toggleProduct(product);
        updateButtons(document);
        updateCount();
        showToast(added ? 'Added to wishlist' : 'Removed from wishlist');
      });
    });
  }

  function showToast(message) {
    var toast = document.querySelector('[data-wishlist-toast]');
    if (!toast) return;

    toast.textContent = message;
    toast.classList.add('is-visible');

    window.clearTimeout(showToast._timer);
    showToast._timer = window.setTimeout(function () {
      toast.classList.remove('is-visible');
    }, TOAST_TIMEOUT);
  }

  function getSelectedKeys(container) {
    return Array.from(container.querySelectorAll('[data-wishlist-select-item]:checked')).map(function (input) {
      return input.value;
    });
  }

  function getSelectedItems(container) {
    var selectedKeys = getSelectedKeys(container);
    var items = getItems();

    if (!selectedKeys.length) return items;

    return items.filter(function (item) {
      return selectedKeys.indexOf(String(item.key)) !== -1;
    });
  }

  function updateSelectionState(container) {
    var allInputs = Array.from(container.querySelectorAll('[data-wishlist-select-item]'));
    var selected = allInputs.filter(function (input) { return input.checked; }).length;
    var selectAll = container.querySelector('[data-wishlist-select-all]');
    var summary = container.querySelector('[data-wishlist-selection-summary]');

    if (summary) {
      summary.textContent = selected + ' selected';
    }

    if (selectAll) {
      selectAll.checked = allInputs.length > 0 && selected === allInputs.length;
      selectAll.indeterminate = selected > 0 && selected < allInputs.length;
    }
  }

  function renderWishlistPage() {
    var container = document.querySelector('[data-wishlist-page]');
    if (!container) return;

    var empty = container.querySelector('[data-wishlist-empty]');
    var grid = container.querySelector('[data-wishlist-grid]');
    var toolbar = container.querySelector('[data-wishlist-toolbar]');
    var printDate = container.querySelector('[data-wishlist-print-date]');
    var items = getItems();

    if (!grid) return;

    grid.innerHTML = '';

    if (printDate) {
      printDate.textContent = new Date().toLocaleDateString();
    }

    if (!items.length) {
      if (empty) empty.style.display = 'block';
      if (toolbar) toolbar.style.display = 'none';
      updateSelectionState(container);
      return;
    }

    if (empty) empty.style.display = 'none';
    if (toolbar) toolbar.style.display = 'grid';

    items.forEach(function (item) {
      var card = document.createElement('article');
      card.className = 'wishlist-card';
      card.setAttribute('data-wishlist-item', item.key);

      var variantMarkup = item.variant_title
        ? '<div class="wishlist-card__variant">' + escapeHtml(item.variant_title) + '</div>'
        : '';

      card.innerHTML =
        '<input class="wishlist-card__check" type="checkbox" data-wishlist-select-item value="' + item.key + '">' +
        '<a href="' + item.url + '" class="wishlist-card__image-link">' +
          '<div class="wishlist-card__image-wrap">' +
            (item.image ? '<img src="' + item.image + '" alt="' + escapeHtml(item.title) + '" class="wishlist-card__image">' : '') +
          '</div>' +
        '</a>' +
        '<div class="wishlist-card__body">' +
          '<h2 class="wishlist-card__title"><a href="' + item.url + '">' + escapeHtml(item.title) + '</a></h2>' +
          variantMarkup +
          (item.price ? '<div class="wishlist-card__price">' + item.price + '</div>' : '') +
          '<div class="wishlist-card__controls">' +
            '<div class="wishlist-qty">' +
              '<button type="button" data-wishlist-qty-minus="' + item.key + '">-</button>' +
              '<input type="number" min="1" value="' + item.quantity + '" data-wishlist-qty-input="' + item.key + '">' +
              '<button type="button" data-wishlist-qty-plus="' + item.key + '">+</button>' +
            '</div>' +
            '<div class="wishlist-card__actions">' +
              '<button type="button" class="wishlist-card__button wishlist-card__button--primary" data-wishlist-add-cart="' + item.key + '">Add to cart</button>' +
              '<button type="button" class="wishlist-card__button" data-wishlist-remove="' + item.key + '">Remove</button>' +
            '</div>' +
          '</div>' +
        '</div>';

      grid.appendChild(card);
    });

    bindWishlistPageActions(container);
    updateSelectionState(container);
  }

  function bindWishlistPageActions(container) {
    if (!container || container.dataset.pageBound === 'true') {
      bindDynamicWishlistActions(container);
      return;
    }

    container.dataset.pageBound = 'true';

    var selectAll = container.querySelector('[data-wishlist-select-all]');
    var addSelected = container.querySelector('[data-wishlist-add-selected]');
    var shareSelected = container.querySelector('[data-wishlist-share-selected]');
    var printSelected = container.querySelector('[data-wishlist-print-selected]');
    var pdfSelected = container.querySelector('[data-wishlist-pdf-selected]');

    if (selectAll) {
      selectAll.addEventListener('change', function () {
        container.querySelectorAll('[data-wishlist-select-item]').forEach(function (input) {
          input.checked = selectAll.checked;
        });
        updateSelectionState(container);
      });
    }

    if (addSelected) {
      addSelected.addEventListener('click', function () {
        addItemsToCart(getSelectedItems(container));
      });
    }

    if (shareSelected) {
      shareSelected.addEventListener('click', function () {
        shareItems(getSelectedItems(container));
      });
    }

    if (printSelected) {
      printSelected.addEventListener('click', function () {
        printItems(getSelectedItems(container));
      });
    }

    if (pdfSelected) {
      pdfSelected.addEventListener('click', function () {
        printItems(getSelectedItems(container));
      });
    }

    bindDynamicWishlistActions(container);
  }

  function bindDynamicWishlistActions(container) {
    if (!container) return;

    container.querySelectorAll('[data-wishlist-select-item]').forEach(function (input) {
      if (input.dataset.bound === 'true') return;
      input.dataset.bound = 'true';

      input.addEventListener('change', function () {
        updateSelectionState(container);
      });
    });

    container.querySelectorAll('[data-wishlist-remove]').forEach(function (button) {
      if (button.dataset.bound === 'true') return;
      button.dataset.bound = 'true';

      button.addEventListener('click', function () {
        removeProduct(button.getAttribute('data-wishlist-remove'));
        renderWishlistPage();
        updateButtons(document);
        updateCount();
        showToast('Removed from wishlist');
      });
    });

    container.querySelectorAll('[data-wishlist-add-cart]').forEach(function (button) {
      if (button.dataset.bound === 'true') return;
      button.dataset.bound = 'true';

      button.addEventListener('click', function () {
        var key = button.getAttribute('data-wishlist-add-cart');
        var quantityInput = container.querySelector('[data-wishlist-qty-input="' + key + '"]');
        var quantity = quantityInput ? quantityInput.value : 1;

        addItemsToCart(
          getItems().filter(function (item) {
            return item.key === String(key);
          }).map(function (item) {
            item.quantity = Math.max(parseInt(quantity, 10) || 1, 1);
            return item;
          })
        );
      });
    });

    container.querySelectorAll('[data-wishlist-qty-minus]').forEach(function (button) {
      if (button.dataset.bound === 'true') return;
      button.dataset.bound = 'true';

      button.addEventListener('click', function () {
        var key = button.getAttribute('data-wishlist-qty-minus');
        var input = container.querySelector('[data-wishlist-qty-input="' + key + '"]');
        var nextValue = Math.max((parseInt(input.value, 10) || 1) - 1, 1);
        input.value = nextValue;
        updateQuantity(key, nextValue);
      });
    });

    container.querySelectorAll('[data-wishlist-qty-plus]').forEach(function (button) {
      if (button.dataset.bound === 'true') return;
      button.dataset.bound = 'true';

      button.addEventListener('click', function () {
        var key = button.getAttribute('data-wishlist-qty-plus');
        var input = container.querySelector('[data-wishlist-qty-input="' + key + '"]');
        var nextValue = (parseInt(input.value, 10) || 1) + 1;
        input.value = nextValue;
        updateQuantity(key, nextValue);
      });
    });

    container.querySelectorAll('[data-wishlist-qty-input]').forEach(function (input) {
      if (input.dataset.bound === 'true') return;
      input.dataset.bound = 'true';

      input.addEventListener('change', function () {
        var key = input.getAttribute('data-wishlist-qty-input');
        var quantity = Math.max(parseInt(input.value, 10) || 1, 1);
        input.value = quantity;
        updateQuantity(key, quantity);
      });
    });
  }

  function addItemsToCart(items) {
    if (!items.length) {
      showToast('Select at least one product');
      return;
    }

    var invalid = items.some(function (item) {
      return !item.variant_id;
    });

    if (invalid) {
      showToast('Please re-add the item with a valid variant');
      return;
    }

    var payload = {
      items: items.map(function (item) {
        return {
          id: parseInt(item.variant_id, 10),
          quantity: Math.max(parseInt(item.quantity || 1, 10) || 1, 1)
        };
      })
    };

    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Cart request failed');
        }
        return response.json();
      })
      .then(function () {
        showToast('Added to cart');
        window.location.href = window.routes.cart_url;
      })
      .catch(function () {
        showToast('Could not add items to cart');
      });
  }

  function shareItems(items) {
    if (!items.length) {
      showToast('Select at least one product');
      return;
    }

    var text = items.map(function (item) {
      var line = item.title;
      if (item.variant_title) {
        line += ' (' + item.variant_title + ')';
      }
      line += ' - ' + window.location.origin + item.url;
      return line;
    }).join('\n');

    if (navigator.share) {
      navigator.share({
        title: 'My Wishlist',
        text: text
      }).catch(function () {});
      return;
    }

    navigator.clipboard.writeText(text).then(function () {
      showToast('Wishlist links copied');
    }).catch(function () {
      showToast('Could not copy links');
    });
  }

  function printItems(items) {
    if (!items.length) {
      showToast('Select at least one product');
      return;
    }

    var printGrid = document.querySelector('[data-wishlist-grid]');
    if (!printGrid) return;

    var allCards = Array.from(printGrid.children);

    allCards.forEach(function (card) {
      var key = card.getAttribute('data-wishlist-item');
      var visible = items.some(function (item) {
        return String(item.key) === String(key);
      });
      card.style.display = visible ? '' : 'none';
    });

    window.print();

    window.setTimeout(function () {
      allCards.forEach(function (card) {
        card.style.display = '';
      });
    }, 400);
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function init(scope) {
    bindButtons(scope);
    updateButtons(scope || document);
    updateCount();
    renderWishlistPage();
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });

  document.addEventListener('wishlist:updated', function () {
    updateCount();
    updateButtons(document);
    renderWishlistPage();
  });

  window.ThemeWishlist = {
    init: init,
    read: getItems,
    hasProduct: hasProduct
  };
})();
